import { callApi, callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';
import { Template } from '@/types/template';

export const getTemplates = async (): Promise<ApiResult<Template[]>> => {
  const { status, result } = await callApi<Template[]>(
    `templates`,
    'GET',
    undefined,
    undefined,
    undefined,
    undefined,
    true
  );
  return { status, result };
};

export const getStaffTemplates = async (
  lineID: string,
  accessToken: string
): Promise<ApiResult<Template[]>> => {
  const { status, result } = await callApiWithoutToken<Template[]>(
    `line/${lineID}/templates`,
    'GET',
    accessToken
  );
  return { status, result };
};
